import { gql } from "@apollo/client";

const CLASS_STYLE_FRAGMENT = gql`
  fragment ClassStyleFragment on ClassStyle {
    id
    name
    slug
    hidden
    sortIndex
    classCount
  }
`;

export const GET_LIST_CLASS_STYLES = gql`
  ${CLASS_STYLE_FRAGMENT}
  query AllClassStyles($sort: OrderByInput, $pagination: ConnectionArgs, $filter: ClassStyleFilterInput) {
    admin {
      classStyles(sort: $sort, pagination: $pagination, filter: $filter) {
        totalCount
        edges { node { ...ClassStyleFragment } cursor }
        pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
      }
    }
  }
`;

export const GET_ONE_CLASS_STYLE = gql`
  ${CLASS_STYLE_FRAGMENT}
  query ClassStyleById($id: String!) {
    admin { classStyleById(id: $id) { ...ClassStyleFragment } }
  }
`;

export const CREATE_CLASS_STYLE = gql`
  ${CLASS_STYLE_FRAGMENT}
  mutation CreateClassStyle($input: ClassStyleCreateInput!) {
    adminClassStyleCreate(input: $input) { ...ClassStyleFragment }
  }
`;

export const UPDATE_CLASS_STYLE = gql`
  ${CLASS_STYLE_FRAGMENT}
  mutation UpdateClassStyle($input: ClassStyleUpdateInput!) {
    adminClassStyleUpdate(input: $input) { ...ClassStyleFragment }
  }
`;

export const DELETE_CLASS_STYLE = gql`
  mutation DeleteClassStyle($classStyleId: String!) {
    adminClassStyleDelete(classStyleId: $classStyleId)
  }
`;
